export const blockIconsEditorBorderColor = (
	<span className='material-symbols-outlined'>border_color</span>
);
